<div class="chart-pagination">
  <div class="area-sections">
    @for (areaSectionPageStyle of deltaEViewModel.areaSectionPagesStyles; track i; let i = $index) {
      <div class="area-section" (click)="onAreaSectionClick($event, i)" [ngStyle]="areaSectionPageStyle"
        >
      </div>
    }
    <span class="active-section" [ngStyle]="deltaEViewModel.activeAreaSectionPagesStyles"></span>
  </div>
  <div class="area-section-pages">
    @for (areaSectionPageStyle of deltaEViewModel.areaSectionPagesStyles; track i; let i = $index) {
      <a href="#" class="area-section-page" (click)="onAreaSectionClick($event, i)"
        [ngStyle]="areaSectionPageStyle"
        >
        <span [ngClass]="{'is-active': deltaEViewModel.active === i}">{{ 'pagination.page' | translate }} {{i + 1}}</span>
        <!--<span [ngClass]="{'is-active': deltaEViewModel.active === i}">{{ 'pagination.page' | translate }} {{i + 1}} - {{ iFdgData?.pageEndDates[i] }}</span>-->
        @if (iFdgData | areTinterAdditionsOnPage : tinterAdditions : i) {
          <div>
            <mat-icon class="is-solid" size="10">circle</mat-icon>
          </div>
        }
        @if (pageDockingDateColors && pageDockingDateColors[i] && pageDockingDateColors[i].length > 0) {
          <div class="flex-row">
            @for (pageDockingDateColor of pageDockingDateColors[i]; track pageDockingDateColor.color) {
              <div>
                <mat-icon class="docking-indicator" size="10" [ngStyle]="{'color': pageDockingDateColor.color }">square</mat-icon>
              </div>
            }
          </div>
        }
      </a>
    }
  </div>

  <canvas height="50" #chartCanvasDEG class="chart-canvas"></canvas>

</div>
